// promo-popup.js — Beauty Charms welcome popup behaviour
(function () {
  const popup = document.getElementById('bc-promo-popup');
  if (!popup) return;

  const STORAGE_KEY = 'bc_promo_popup_last_shown';
  const delay = parseInt(popup.dataset.delay || '2000', 10);
  const frequency = popup.dataset.frequency || 'session';
  const disableOnMobile = popup.dataset.disableMobile === 'true';

  if (disableOnMobile && window.innerWidth <= 749) return;

  function shouldShow() {
    if (frequency === 'always') return true;

    if (frequency === 'session') {
      return sessionStorage.getItem(STORAGE_KEY) !== 'true';
    }

    if (frequency === 'day') {
      const last = localStorage.getItem(STORAGE_KEY);
      if (!last) return true;
      const oneDay = 24 * 60 * 60 * 1000;
      return Date.now() - parseInt(last, 10) > oneDay;
    }

    return true;
  }

  function markShown() {
    if (frequency === 'session') {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    } else if (frequency === 'day') {
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
    }
  }

  function openPopup() {
    popup.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    markShown();
  }

  function closePopup() {
    popup.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  popup.querySelectorAll('[data-bc-popup-close]').forEach((el) => {
    el.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
  });

  if (shouldShow()) {
    setTimeout(openPopup, delay);
  }
})();
